import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import type { SecondaryMarketProductInternalUser } from 'state/secondaryMarket/productSearch';
import styled from 'styled-components';

interface GridItemProps {
  children: ReactNode;
  label: IntlKey;
  e2e?: string;
}

const GridItem: FC<GridItemProps> = ({ label, children, e2e }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="border d-flex flex-column p-2 align-items-start">
      <div className="text-secondary">{formatMessage({ id: label })}</div>
      <div className="text-primary fw-bold" data-e2e={`${e2e}-value`}>
        {children}
      </div>
    </div>
  );
};

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.5rem;
`;
export const GridItems: FC<{ data: SecondaryMarketProductInternalUser }> = ({ data: { isin, fileCode } }) => {
  return (
    <StyledGrid>
      <GridItem label="secondaryMarket.modal.fileCode">{fileCode ?? '-'}</GridItem>
      <GridItem label="secondaryMarket.modal.isin">{isin ?? '-'}</GridItem>
    </StyledGrid>
  );
};
